import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/use-auth-compat';
import { getOfferings } from '@/services/OfferingServices';
import type { OfferingResponse } from '@/types/offering';

export function useMyOfferings(enabled: boolean = true) {
  const auth = useAuth();
  return useQuery<OfferingResponse[]>({
    queryKey: ['myOfferings'],
    queryFn: async () => {
      // Fresh token from the same accessor handlePublish/handleSaveDraft use in
      // CreateOfferingWizard.tsx (NOT a mount-time token value, which can be stale).
      const tok = await auth.getToken();
      if (!tok) {
        // Throwing puts the query into isError state — this is the fail-closed signal
        // a caller uses to distinguish "fetch failed" from "teacher has zero offerings".
        throw new Error('Not authenticated');
      }
      const data = await getOfferings(tok);
      return Array.isArray(data) ? data : (data?.offerings ?? []);
    },
    enabled,
    staleTime: 60 * 1000,
    retry: false, // errors must surface immediately so a caller's forced refetch() can fail closed
  });
}
